export const common = {
  // Navigation
  "nav.home": "Inicio",
  "nav.about": "Sobre Nosotros",
  "nav.services": "Servicios",
  "nav.products": "Productos",
  "nav.certifications": "Certificaciones", 
  "nav.partnerships": "Asociaciones",
  "nav.contact": "Contacto",
  "nav.quote": "Obtener Cotización",
  
  // Common buttons
  "button.learnMore": "Saber Más",
  "button.getQuote": "Obtener Cotización",
  "button.contactUs": "Contáctanos",
  "button.viewAll": "Ver Todo",
  "button.download": "Descargar",
  
  // Common text
  "company.name": "GRUPO DRIXEM",
  "company.tagline": "Especialistas Malayos en Aceite de Palma",
  "language.current": "Español"
};

export default common;